function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Anchor, Avatar, Container, SimpleGrid, Text, Title } from '@mantine/core';
import React from 'react';
import Panel from '../Panel';
import styles from './InfoPanels.module.scss';
import { FormattedMessage, useIntl } from 'react-intl';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { ExternalUrls, WebRoutes } from '@/utils/constants';
import Icon, { IconSizes } from '../Icon';
import { faBookAtlas, faCloudBolt, faCode, faCodeBranch, faUserGroup, faUserPlus } from '@fortawesome/free-solid-svg-icons';
function InfoPanel(param) {
    var title = param.title, description = param.description, icon = param.icon, avatarClassName = param.avatarClassName, anchorProps = param.anchorProps;
    var _ref = anchorProps !== null && anchorProps !== void 0 ? anchorProps : {}, anchorClassName = _ref.className, anchorPropsRest = _object_without_properties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ _jsxs(Panel, {
        className: styles.infoPanel,
        children: [
            /*#__PURE__*/ _jsx(Avatar, {
                radius: "md",
                size: "sm",
                className: classNames(styles.infoPanelAvatar, avatarClassName),
                children: /*#__PURE__*/ _jsx(Icon, {
                    icon: icon,
                    size: IconSizes.MD,
                    className: styles.infoPanelAvatarIcon
                })
            }),
            /*#__PURE__*/ _jsx(Title, {
                order: 2,
                children: title
            }),
            /*#__PURE__*/ _jsx(Text, {
                c: "dimmed",
                children: description
            }),
            /*#__PURE__*/ _jsx(Anchor, _object_spread_props(_object_spread({
                className: classNames(styles.infoPanelLink, anchorClassName)
            }, anchorPropsRest), {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "TdTXXf",
                    defaultMessage: "Learn more"
                })
            }))
        ]
    });
}
export default function InfoPanels(_param) {
    var className = _param.className, props = _object_without_properties(_param, [
        "className"
    ]);
    var intl = useIntl();
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        className: classNames(styles.infoPanels, className)
    }, props), {
        children: /*#__PURE__*/ _jsxs(Container, {
            size: "xl",
            className: styles.infoPanelsContainer,
            children: [
                /*#__PURE__*/ _jsx(Title, {
                    className: styles.title,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "VdPdO1",
                        defaultMessage: "Powerful & Flexible"
                    })
                }),
                /*#__PURE__*/ _jsx(Text, {
                    size: "xl",
                    c: "dimmed",
                    className: styles.description,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "AeduSe",
                        defaultMessage: "Nightbot has been helping streamers grow since 2012, and has been enjoyed by millions of content-creators."
                    })
                }),
                /*#__PURE__*/ _jsxs(SimpleGrid, {
                    cols: {
                        base: 1,
                        sm: 2,
                        md: 3
                    },
                    className: styles.infoPanelsGrid,
                    children: [
                        /*#__PURE__*/ _jsx(InfoPanel, {
                            icon: faCloudBolt,
                            avatarClassName: styles.avatarColorIndigo,
                            title: intl.formatMessage({
                                id: "8lC6C0",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Cloud Hosted"
                                    }
                                ]
                            }),
                            description: intl.formatMessage({
                                id: "QVvO1b",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "No downloads, no servers, always online and ready to go."
                                    }
                                ]
                            }),
                            anchorProps: {
                                component: Link,
                                to: WebRoutes.DASHBOARD
                            }
                        }),
                        /*#__PURE__*/ _jsx(InfoPanel, {
                            icon: faCode,
                            avatarClassName: styles.avatarColorGreen,
                            title: intl.formatMessage({
                                id: "MFRAAA",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Extensible"
                                    }
                                ]
                            }),
                            description: intl.formatMessage({
                                id: "AGgJBH",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Add commands using code, built-in variables, and third-party API's."
                                    }
                                ]
                            }),
                            anchorProps: {
                                to: ExternalUrls.DOCS
                            }
                        }),
                        /*#__PURE__*/ _jsx(InfoPanel, {
                            icon: faBookAtlas,
                            avatarClassName: styles.avatarColorPurple,
                            title: intl.formatMessage({
                                id: "E2MClJ",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Action Logging"
                                    }
                                ]
                            }),
                            description: intl.formatMessage({
                                id: "6MaZVu",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Monitor chat activity, command usage, and review triggered moderation rules."
                                    }
                                ]
                            }),
                            anchorProps: {
                                component: Link,
                                to: WebRoutes.LOGS
                            }
                        }),
                        /*#__PURE__*/ _jsx(InfoPanel, {
                            icon: faUserGroup,
                            avatarClassName: styles.avatarColorPink,
                            title: intl.formatMessage({
                                id: "3hzR9A",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Collaborative"
                                    }
                                ]
                            }),
                            description: intl.formatMessage({
                                id: "Fl/EYC",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Add users as Managers to configure Nightbot’s settings on your behalf."
                                    }
                                ]
                            }),
                            anchorProps: {
                                component: Link,
                                to: WebRoutes.SETTINGS
                            }
                        }),
                        /*#__PURE__*/ _jsx(InfoPanel, {
                            icon: faUserPlus,
                            avatarClassName: styles.avatarColorRed,
                            title: intl.formatMessage({
                                id: "F4a/f4",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "User Permissions"
                                    }
                                ]
                            }),
                            description: intl.formatMessage({
                                id: "nElJqE",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Select users, who can be exempt or access special functions of Nightbot."
                                    }
                                ]
                            }),
                            anchorProps: {
                                component: Link,
                                to: WebRoutes.REGULARS
                            }
                        }),
                        /*#__PURE__*/ _jsx(InfoPanel, {
                            icon: faCodeBranch,
                            avatarClassName: styles.avatarColorOrange,
                            title: intl.formatMessage({
                                id: "isGKnz",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Documentation"
                                    }
                                ]
                            }),
                            description: intl.formatMessage({
                                id: "ZS2CGR",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Want to integrate deeper? Check out our API documentation."
                                    }
                                ]
                            }),
                            anchorProps: {
                                href: ExternalUrls.API_DOCS
                            }
                        })
                    ]
                })
            ]
        })
    }));
}
